import styled from 'styled-components/macro';

export const Container = styled.div`
  height: calc(100vh - 50px);
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  max-width: 1920px;
  margin: auto;
  position: relative;
`;
